module.exports = __webpack_public_path__ + "img/fz.1bb49b2d.svg";